import * as React from 'react';
import { graphql } from 'gatsby';
import Section from '../../components/shared/Section';
import s from './ArticleTemplate.module.scss';

interface CellContent {
  text: string;
}

export interface Props {
  id: string;
  internal: {
    type: string;
  };
  wordpress_4_column_table: {
    column_1: Array<CellContent>;
    column_3: Array<CellContent>;
    column_2: Array<CellContent>;
    column_4: Array<CellContent>;
  }[];
}

const renderCell = (cell: Array<CellContent>, i: number) =>
  cell.map((c, j) => (
    <React.Fragment key={`cell-${i}-${j}`}>
      {c.text && <p className={s.cellText}>{c.text}</p>}
    </React.Fragment>
  ));

const desktopTable = (content, header) =>
  content.map((row, i) => (
    <table key={`table-${i}`} className={`${s.table} ${s.desktop} ${s.margin}`}>
      <thead>
        <tr>
          <th>{renderCell(header.column_1, i)}</th>
          <th>{renderCell(header.column_2, i)}</th>
          <th>{renderCell(header.column_3, i)}</th>
          <th>{renderCell(header.column_4, i)}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className={s.bold}>{renderCell(row.column_1, i)}</td>
          <td>{renderCell(row.column_2, i)}</td>
          <td>{renderCell(row.column_3, i)}</td>
          <td>{renderCell(row.column_4, i)}</td>
        </tr>
      </tbody>
    </table>
  ));

const mobileTable = (content, header) =>
  content.map((row, i) => (
    <div key={`table-${i}`} className={s.margin}>
      <table className={`${s.table} ${s.mobile}`}>
        <thead>
          <th>{renderCell(header.column_1, i)}</th>
          <th>{renderCell(header.column_2, i)}</th>
        </thead>
        <tbody>
          <tr>
            <td className={s.bold}>{renderCell(row.column_1, i)}</td>
            <td>{renderCell(row.column_2, i)}</td>
          </tr>
        </tbody>
      </table>
      <table className={`${s.table} ${s.mobile}`}>
        <thead className={s.noBorderTop}>
          <th>{renderCell(header.column_3, i)}</th>
          <th>{renderCell(header.column_4, i)}</th>
        </thead>
        <tbody>
          <tr>
            <td>{renderCell(row.column_3, i)}</td>
            <td>{renderCell(row.column_4, i)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  ));

class TableBlock extends React.Component<Props> {
  state = { isMobile: false };

  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
    this.setState({ isMobile });
  };

  render() {
    const { isMobile } = this.state;
    const { wordpress_4_column_table: table } = this.props;
    const header = table[0];
    const tableContents = table.slice(1);
    return (
      <div className={s.tableBlock}>
        {isMobile
          ? mobileTable(tableContents, header)
          : desktopTable(tableContents, header)}
      </div>
    );
  }
}

export const query = graphql`
  fragment ArticleTableBlockFragment on WordPressAcf_table {
    ... on WordPressAcf_table {
      id
      internal {
        type
      }
      wordpress_4_column_table {
        column_1 {
          text
        }
        column_3 {
          text
        }
        column_2 {
          text
        }
        column_4 {
          text
        }
      }
    }
  }
`;

export default TableBlock;
